import { DATADOG_TAGS_TYPE } from './datadogLogger';

/**
 * Extracts error information from any type of input
 * @param messageOrError - Message string or Error object
 * @returns Processed message and error context
 */
export function processErrorForDatadog(
  error?: Error | string | unknown,
): Record<string, unknown> {
  let errorContext: Record<string, unknown> = {};
  if (error && error instanceof Error) {
    errorContext = {
      errorMessage: error.message,
      errorName: error.name,
      stack: error.stack,
    };
  } else if (error && error instanceof Object) {
    errorContext = { ...error };
  } else if (error) {
    errorContext = { errorMessage: String(error) };
  }

  return errorContext;
}

export async function processResponseForDatadog(
  res: Response,
): Promise<Record<string, unknown>> {
  let resContext: Record<string, unknown> = {};
  try {
    let resBody;
    try {
      resBody = await res.json();
    } catch (error) {
      resBody = await res.text();
    }
    resContext = {
      resStatus: res.status,
      resStatusText: res.statusText,
      url: res.url,
      body: resBody,
    };
  } catch (error) {
    resContext = {
      resStatus: res.status,
      resStatusText: res.statusText,
      url: res.url,
    };
  }
  return resContext;
}

export function processDatadogTags(tags: DATADOG_TAGS_TYPE) {
  return tags
    ? Object.entries(tags)
        .map(([key, value]) => `${key}:${value}`)
        .join(',')
    : '';
}
